module.exports = __webpack_public_path__ + "img/crown.a56a43a7.png";